import React from "react";
import styled from "styled-components";
import { isEmpty } from "ramda";
import { Menu, Icon } from "antd";
import { Colors, Metrics } from "../../theme";
import ROUTE from "../../constants/route";
import MenuItem from "antd/lib/menu/MenuItem";

import UserUtil from "../../util/user";

export const MenuType = {
	ITEM: "item",
	SUB_MENU: "subMenu",
	GROUP: "group",
};
const createSeemMenuStyle = (props) => `
    display: grid;
    align-items:center;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    ${props.fullHeight ? "min-height: 56px;" : ""}
    ${props.hasDivider ? "border-bottom: 1px solid rgba(107, 111, 113, 0.25);" : ""}
    background-color: ${props.selected ? "#FFF" : Colors.menuGreyBackgroundColor} !important;
`;
const ItemContent = styled.div`
    ${props => props.hasDivider ? "border-bottom: 1px solid rgba(107, 111, 113, 0.25);" : ""}
    ${"" /* width: 100%;  */}
    ${"" /* height: 100%; */}
    display: flex;
    align-items: center;
`;
const Item = styled(Menu.Item) `
    ${props => createSeemMenuStyle(props)}
`;
const ItemGroup = styled(Menu.ItemGroup) `
    ${props => createSeemMenuStyle(props)}
`;
const SubMenu = styled(Menu.SubMenu) `
    ${props => createSeemMenuStyle(props)}
`;

const ContentIcon = styled(Icon) `
    font-size: 24px !important;
`;
function createMenuItemLabel({ colorStyle, icon, text, hasDivider = false }) {
	return (<ItemContent hasDivider={hasDivider}>
		{isEmpty(icon) ? undefined : <ContentIcon style={colorStyle} {...icon} />}
		<span style={colorStyle} >{text}</span>
	</ItemContent>);
}
/**
 * Render menu in recursive until there is nomore menu.
 * @param {array} draw_submenus 
 * @param {array} defaultSelectedKeys 
 * @param {object} selectedStyle 
 * @param {array} parentPath 
 */
function recursiveMenuItems(draw_submenu,
	defaultSelectedKeys = [],
	selectedStyle = {},
	parentPath = "",
	isRoot = false,
) {
	if (draw_submenu.length === 0) {
		/// Shouldnt be empty though
		return <div />;
	}
	return draw_submenu.map((itemElement, index) => {
		const {
			submenu = [],
			menuType = MenuType.ITEM,
			icon = {},
			text, key = index, style
		} = itemElement;
		const cyclePath = parentPath === "" ? key : `${parentPath}.${key}`;
		const isSelected = defaultSelectedKeys.findIndex((v) => v === key) !== -1;
		const colorStyle = isSelected ? selectedStyle : {};
		switch (menuType) {
		case MenuType.GROUP:
			return (<ItemGroup key={key}
				hasDivider={true}
				fullHeight={isRoot}
				style={style} {...itemElement} title={createMenuItemLabel({ colorStyle, icon, text })}>
				{recursiveMenuItems(submenu, defaultSelectedKeys, selectedStyle, cyclePath)}
			</ItemGroup>);
		case MenuType.SUB_MENU:
			return (<SubMenu key={key}
				fullHeight={isRoot}
				hasDivider={isRoot}
				title={
					createMenuItemLabel({ colorStyle, icon, text })
				}>
				{recursiveMenuItems(submenu, defaultSelectedKeys, selectedStyle, cyclePath)}
			</SubMenu>);
		default:
			// Default is MenuType.Item
			return <Item selected={isSelected}
				hasDivider={isRoot}
				key={key}
				fullHeight={isRoot}
				style={style} {...itemElement}>
				{createMenuItemLabel({ colorStyle, icon, text })}
			</Item>;
		}
	});
}

export class ContentMenu extends React.Component {
    state = {}

    resize = () => this.forceUpdate()

    componentDidMount() {
    	window.addEventListener("resize", this.resize);
    }

    componentWillUnmount() {
    	window.removeEventListener("resize", this.resize);
    }

    render() {
    	const props = this.props;
    	const { menuItemProps, MenuContainer, theme } = props;


    	const selectedStyle = { color: theme.mainColor };
    	const contentMenuHeight = window.innerHeight - 64 - 48;
    	return (
    		<Menu
    			theme="dark"
    			defaultSelectedKeys={MenuContainer.defaultSelectedKeys}
    			defaultOpenKeys={MenuContainer.defaultOpenKeys}
    			style={{ overflowY: "scroll", height: contentMenuHeight, backgroundColor: "#32323a" }}
    			mode="inline"
    			inlineIndent={12}
    			{...MenuContainer}
    		>
    			{
    				recursiveMenuItems(menuItemProps, MenuContainer.defaultSelectedKeys, selectedStyle, "", true)
    			}
    		</Menu>
    	);
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/Menu.js